import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import * as React from 'react';

export const ARIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="-19.5 44.5 24 24">
            <rect x="-0.5" y="44.5" width="2" height="6"/>
            <rect x="-2.5" y="46.5" width="6" height="2"/>
            <g>
                <path d="M-10.396,63.5l-0.796-2.846h-4.003L-15.99,63.5H-18.5l3.876-12h2.847l3.891,12H-10.396z M-11.748,58.529c-0.736-2.578-1.151-4.035-1.244-4.373c-0.092-0.338-0.159-0.605-0.199-0.801c-0.165,0.697-0.638,2.422-1.419,5.174H-11.748z"/>
                <path d="M-5.172,58.896V63.5H-7.5v-12h3.2c1.493,0,2.598,0.295,3.313,0.891c0.716,0.594,1.073,1.496,1.073,2.705c0,0.705-0.178,1.334-0.532,1.885c-0.355,0.551-0.859,0.979-1.511,1.291c1.652,2.697,2.729,4.441,3.23,5.229h-2.584l-2.622-4.604H-5.172L-5.172,58.896z M-5.172,56.826h0.752c0.735,0,1.279-0.135,1.629-0.402c0.351-0.268,0.525-0.688,0.525-1.264c0-0.568-0.179-0.975-0.537-1.215c-0.357-0.24-0.912-0.361-1.664-0.361h-0.705V56.826L-5.172,56.826z"/>
            </g>
        </SvgIcon>
    );
};

export const ThinARIcon: React.FC<SvgIconProps> = (props) => {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <polygon fill="currentColor" points="23 4 21 4 21 2 20 2 20 4 18 4 18 5 20 5 20 7 21 7 21 5 23 5 23 4"/>
            <g>
                <path fill="currentColor" d="M6.42,8h1.23l4.29,11h-1.38l-1.15-2.97H4.66l-1.15,2.97h-1.41L6.42,8Zm-1.27,6.77h3.77l-1.89-4.89-1.89,4.89Z"/>
                <path fill="currentColor" d="M13.1,8h2.86c2.18,0,3.68,1.29,3.68,3.25,0,2.61-2.37,3.1-2.69,3.14l3.05,4.6h-1.59l-2.97-4.49h-1.02v4.49h-1.32V8Zm5.22,3.25c0-1.21-.8-2-2.28-2h-1.62v3.99h1.62c1.48,0,2.28-.79,2.28-2Z"/>
            </g>
        </SvgIcon>
    );
};